function holdingFooterHeight() {
	const footer = document.querySelector('.holding-footer');
	if (!footer) return;
	const main = document.querySelector('main.content');
	main.style.marginBottom = footer.offsetHeight + 'px';
}

holdingFooterHeight();


let footerResizeTimer;
let fvw = window.innerWidth;

window.addEventListener('resize', (e) => {
	clearTimeout(footerResizeTimer);
	let new_fvw = window.innerWidth;

	if (new_fvw !== fvw) {
		footerResizeTimer = setTimeout(() => {
			holdingFooterHeight();
			fvw = window.innerWidth;
		}, 10);
	}
});